import { WEB_URL } from '@/config/endpoints';
import IMAGES from '@/public/assets/img';


export default {
    ShimmerSec:false,
    WhatsAppText:{
        labelText:'Connect to Whats app',
        desktopNo:'+919953052228',
        desktopMessage:"Hi, Welcome to Credlix's official WhatsApp account",
        mobileNo:'+917838156656',
        mobileMessage:"I'm interested in exploring Credlix's innovative financing solutions",
        contactName:'Credlix Official'
    },
    MenuLinks:[
        {name:'Financing Solutions', href:WEB_URL+'/en-us/export-factoring', 
            subMenu:[
                { name: 'Export Factoring', href: WEB_URL+'/en-us/export-factoring' ,src: IMAGES.SHARED.sbDiscount},
                
                
            ]
        },
        {name:'Global Buyer', href:WEB_URL+'/en-us/global-buyer',subMenu:null },
        {name:'Tools', href:null, subMenu:[
            { name: 'Interest Calculator', href: WEB_URL+'/en-us/interest-calculator', text: 'Calculate Best Pricing For Export Financing', src: IMAGES.SHARED.iCalc },
            ]
        },
        {name: 'About Us', href: WEB_URL+'/en-us/about-us',subMenu:null},
        { name: 'Partner Program', href: WEB_URL+'/en-us/partner-program' ,src: IMAGES.SHARED.pProgram}
        // {name:'Resources', href:'/blogs', subMenu:null},
    ],
    Login: {name:'Login', href:'https://app.credlix.com/#/auth/login'},
    SignUp:{name:'Signup', href:'https://app.credlix.com/nuphi/#/signup/exporter/verify'},
    

    // Content For footer starts
    FooterIndiaForm:false,
    FooterMexicoForm:false,
    FooterUSForm:true,
    FooterLeftText:{
        heading:'Optimize your cash flow with Credlix and convert your accounts receivable into cash',
        para:'Register on our platform and share some details about your company with us to provide you with a simple, personalized service tailored to your needs so that you can unleash the potential of your exports.',
        list:[
            'An ISO certified company',
            'Instant approval, quick disbursal',
            'Minimal documentation, no hard collateral',
            '100% visibility, digital dashboards',
            'FCI Member',
        ]
    },
    Scanner:false,
    MexicoFormFieldsLabels:{
        commonError:'This field is required.',
        emailNotValid:'Email is not valid.',
        restrictEmail:"Kindly provide the official email associated with the company.",
        phoneInvalid:'Phone no is not valid.',
        heading1:'Get immediate access to',
        heading2:'WORKING CAPITAL',
        emailLabel:'Email*',
        emailPlaceholder:'Enter your email',
        phoneLabel:'Phone number*',
        phonePlaceholder:'Enter your phone number',
        companyLabel:'Company Name*',
        companyPlaceholder:'Enter your company name',
        financeLabel:'Required financing*',
        mIFinanceLabel:'Required financing (optional)',
        financePlaceholder:'Enter your financing amount',
        submit:'Get Financing',
        successMsg:'Successfull Submission : Thank you for your interest. ',
        countrycodeLabel: 'Country Code',
        countrycodePlaceholder: 'Select',
        companytypeLabel: 'Company Type*',           
        companytypePlaceholder: 'Enter your company Type',
        countrycodeData: [
              { id: 1, code: 'Canada (+1)', Showname: 'Canada (+1)' },
              { id: 2, code: 'USA (+1)', Showname: 'United States (+1)' },
              { id: 3, code: 'Mexico (+52)', Showname: 'Mexico (+52)' }
            ],
        mITradeHeading:'Simplify your imports from India — Connect now',
        mISubBtn:'Connect Now'
    },
    miSupplier:{
        otpVerified:'OTP verified!',
        connectHeading:'Connect with Mexican Buyers — Apply Now'
    },
    fixedCTA:'Get Financed',
    Address:{
        country:'United States',
        addressName:{
            name:'Address',
            content:'24 Union Square #305,Union City, California 94587 USA'
        },
        email:'Email',
        emailId:'genette.herrera@moglix.com',
        contact:'Contact',
        phone:'+52 55 4544 9526'
    },
    copyright:'Copyright © ',
    ExitForm:true,
    BlueBgHeading:'Do more for your Supply Chain with',
    SuppList:[
        {image:IMAGES.SHARED.ftIcon1,boldText:'An ISO,',text:'Certified Company'},
        {image:IMAGES.SHARED.ftIcon2,boldText:'Minimal Documentation,',text:'no Hard Collateral'},
        {image:IMAGES.SHARED.ftIcon3,boldText:'Instant Approval,',text:'quick disbursal'},
        {image:IMAGES.SHARED.ftIcon4,boldText:'100 % visibility,',text:'digital dashboards'},
    ],
    ThankyouResponse:{
        ThankYou_page_heading:'Thank you for contacting with us.',
        ThankYou_page_para:'We will get back to you shortly',
    },
    SeoContent:{
        title:'Thank You for contacting',
        url:WEB_URL+'/en-us/thankyou-response',
        name:'description',
        description:'Thank You for contacting.'
    },
    ResLinks:false,
    pageNotFound:{
        title:'Page Not Found',
        description:'Sorry, the page you are looking for could not be found.',

    },
    pageGone: {
        title: 'Page No Longer Available',
        description: 'This page is no longer available as the requested content has been permanently removed.',
        metaTitle: '410 - Page No Longer Available | Credlix',
        metaDescription: 'This page is no longer available as the requested content has been permanently removed.',
        returnTextPrefix: 'Or you can return to our ',
        homePageText: 'home page',
        homePageUrl: '/en-us',
        returnTextMiddle: ', or ',
        contactUsText: 'contact us',
        contactUsUrl: '/en-us/contact-us',
        returnTextSuffix: '.'
    }

     // Content For footer end

}